// Define Action Types
export const FETCH_PRIORITIES_REQUESTED = 'FETCH_PRIORITIES_REQUESTED';
export const FETCH_PRIORITIES_COMPLETED = 'FETCH_PRIORITIES_COMPLETED';
export const FETCH_PRIORITIES_ERROR = 'FETCH_PRIORITIES_ERROR';

// Define Actions
export const getPrioritiesAsync = () => ({
  type: FETCH_PRIORITIES_REQUESTED,
});
